var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
Vue.use(Viewer);
Viewer.setDefaults({
    title: false,
    toolbar: true
});
var SignView = (function (_super) {
    __extends(SignView, _super);
    function SignView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.imageVisible = false;
        return _this;
    }
    SignView.prototype.closeDio = function () {
        this.$emit('closeimg', false);
    };
    __decorate([
        Prop({
            type: Array
        })
    ], SignView.prototype, "imageArr", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false,
        })
    ], SignView.prototype, "imageOpen", void 0);
    SignView = __decorate([
        Component({
            components: {},
        })
    ], SignView);
    return SignView;
}(Vue));
export default SignView;
